module.exports = __webpack_public_path__ + "img/cutaway_stopped.5192f76c.svg";